import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { CursorPage, GraphUser, GraphUserSearchQuery } from '@gbr-monorepo/interfaces';
import { GraphUserServiceContract } from '@gbr-monorepo/user-mgmt-ui';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class GraphUserService extends GraphUserServiceContract {
    private readonly httpClient = inject(HttpClient);
    private readonly apiUrl = `${environment.apiUrl}/v1/graph/users`;

    public findUsers(search: GraphUserSearchQuery): Observable<CursorPage<GraphUser>> {
        return this.httpClient.get<CursorPage<GraphUser>>(this.apiUrl, { params: this.buildParams(search) });
    }

    public getUserByEmployeeId(employeeId: string): Observable<GraphUser | undefined> {
        const url = `${this.apiUrl}/${employeeId}`;
        return this.errorPipe(this.httpClient.get<GraphUser>(url));
    }

    public getUserByEmail(email: string): Observable<GraphUser | undefined> {
        return this.errorPipe(
            this.httpClient
                .get<CursorPage<GraphUser>>(this.apiUrl, { params: new HttpParams().set('mail', email) })
                .pipe(map(response => response.items[0]))
        );
    }

    private buildParams(search: GraphUserSearchQuery): HttpParams {
        let params = new HttpParams();
        if (search.employeeId) params = params.set('employeeId', search.employeeId);
        if (search.mail) params = params.set('mail', search.mail);
        if (search.firstname) params = params.set('firstname', search.firstname);
        if (search.surname) params = params.set('surname', search.surname);
        if (search.skipToken) params = params.set('skipToken', search.skipToken);
        return params;
    }

    private errorPipe<T>(request: Observable<T>): Observable<T | undefined> {
        return request.pipe(catchError(() => of(undefined)));
    }
}
